import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function DarkModeIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M8.97083 13.5c0.84991 0 1.62497 -0.0949 2.32087 -0.2803 0.4699 -0.1253 0.4219 -0.7508 -0.0119 -0.9687C9.47415 11.3441 8.49856 9.54591 8.49856 7s0.97559 -4.34406 2.78124 -5.251c0.4338 -0.21788 0.4818 -0.843416 0.0119 -0.968677C10.5958 0.594856 9.82074 0.5 8.97083 0.5 4.7495 0.5 2.375 2.84 2.375 7s2.3745 6.5 6.59583 6.5Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
